import React from "react";
import { Title, Container } from "../general";

const Pricing = () => {
  return (
    <div className="mt-8 w-full" id="pricing">
      <Title className="text-center" fontSize="3xl">
        Pricing
      </Title>
      <Container className="bg-yellow w-full p-24 flex flex-col items-center justify-center text-center">
        <h2 className="font-bold text-white mb-2 text-xl">
          <span role="img" aria-label="">
            🎉
          </span>
          &nbsp; IT'S COMPLETELY FREE! &nbsp;
          <span role="img" aria-label="">
            🎉
          </span>
        </h2>
        <h2 className="text-primary text-lg underline font-semibold">
          Premium Coming Soon!
        </h2>
      </Container>
    </div>
  );
};

export default Pricing;
